import { render, staticRenderFns } from "./MailForwardingInstructions.vue?vue&type=template&id=1a414a44"
import script from "./MailForwardingInstructions.vue?vue&type=script&lang=js"
export * from "./MailForwardingInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports